export enum UpgradeModalUids {
  GENERIC_UPGRADE_MODAL_SUBNAV = 'generic-upgrade-modal-subnav',
  GENERIC_UPGRADE_MODAL_GREET_CREATION = 'generic-upgrade-modal-greet-creation-flow',
  REMOVE_BONJORO_BADGE_UPGRADE_MODAL = 'remove-bonjoro-badge-upgrade-modal',
  NEXT_GEN_TEMPLATE_UPGRADE_MODAL = 'next-gen-template-upgrade-modal',
  TEAMS_UPGRADE_MODAL = 'teams-upgrade-modal',
  WORKFLOW_FILTERS_MODAL = 'workflow-filters-upgrade-modal',
  REMOVE_POWERED_BY_BONJORO_MODAL = 'remove-powered-by-bonjoro-modal',
  TESTIMONIAL_UPGRADE_MODAL = 'testimonial-upgrade-modal',
}

export enum PlanCardsUids {
  GENERIC_UPGRADE_MODAL_SUBNAV_PLANCARDS = 'generic-upgrade-modal-subnav-plancards',
  GENERIC_UPGRADE_MODAL_GREET_CREATION_PLANCARDS = 'generic-upgrade-modal-greet-creation-plancards',
  REMOVE_BONJORO_BADGE_UPGRADE_MODAL_PLANCARDS = 'remove-bonjoro-badge-upgrade-modal-plancards',
  TEAMS_UPGRADE_MODAL_PLANCARDS = 'teams-upgrade-modal-plancards',
  WORKFLOW_FILTERS_MODAL_PLANCARDS = 'workflow-filters-upgrade-modal-plancards',
  REMOVE_POWERED_BY_BONJORO_MODAL_PLANCARDS = 'remove-powered-by-bonjoro-modal-plancards',
  NEXT_GEN_TEMPLATE_UPGRADE_MODAL_PLANCARDS = 'next-gen-template-upgrade-modal-plancards',
  TESTIMONIAL_UPGRADE_MODAL_PLANCARDS = 'testimonial-upgrade-modal-plancards',
  GENERIC_PLAN_CARDS = 'new-generic-plan-cards',
}

export enum StripePaymentModalUids {
  GENERIC_UPGRADE_MODAL_SUBNAV_PAYMENT = 'generic-upgrade-modal-subnav-payment',
  GENERIC_UPGRADE_MODAL_GREET_CREATION_PAYMENT = 'generic-upgrade-modal-greet-creation-payment',
  REMOVE_BONJORO_BADGE_UPGRADE_MODAL_PAYMENT = 'remove-bonjoro-badge-upgrade-payment',
  TEAMS_UPGRADE_MODAL_PAYMENT = 'teams-upgrade-modal-payment',
  WORKFLOW_FILTERS_MODAL_PAYMENT = 'workflow-filters-upgrade-modal-payment',
  REMOVE_POWERED_BY_BONJORO_MODAL_PAYMENT = 'remove-powered-by-bonjoro-upgrade-payment',
  NEXT_GEN_TEMPLATE_UPGRADE_MODAL_PAYMENT = 'next-gen-template-upgrade-modal-stripe-payment',
  TESTIMONIAL_UPGRADE_MODAL_PAYMENT = 'testimonial-upgrade-modal-payment',
}

export interface UpgradeModalKeyProps {
  upgradeModalUid: UpgradeModalUids;
  planCardsUid: PlanCardsUids;
  stripePaymentModalUid: StripePaymentModalUids;
}
